import { setTerm } from './helpers';

export const setWithFurniture = setTerm('with_furniture');
